const newEquipment = {
  plant: "Plant",
  equipment: "Create a new Equipment",
  backbtn: "Go Back",
  modulesButton: "Modules",
  equipmentTag: "Equipment Tag",
  mechanical: "Cooling Lubricant Code",
  customer: "Customer",
  equipmentType: "Equipment Type",
  typeContract: "Type of Contract",
  statuslights: {
    running: "Running",
    standby: "Standby",
    maintenance: "Maintenance",
    failure: "Failure"
  },
  tabs: {
    info: "BASIC INFO",
    values: "OPERATIONAL VALUES",
    ranges: "VARIABLE RANGES"
  },
  equipmentStatus: "Mechanical condition of the equipment",
  area: "Area",
  location: "Select Location",
  selectPlant: "Select Plant",
  selectArea: "Select Area",
  selectUnit: "Select Unit",
  unit: "Unit",
  sealTypes: "Mechanical Seal Types",
  hazardous: "Hazardous Area Classification",
  createdBy: "Created By",
  dateCreated: "Date Created",
  comment: "Comment",
  pumpHousing: "Pump Housing",
  deleteEquipment: "Delete Equipment",
  snackText: "Your new equipment has been created",
  submit: "Submit",
  picture: "Image",
  machineHealthIndex: "Machine Health Index",
  mechanicalCondition: "Equipment operating condition",
  manufacturer: "Manufacturer"
};
export default newEquipment;
